/**
 * user - register
 *
 * @author Shigq
 * @date 2021/6/3 11:42
 */
import { t, REQ_ITEM_TYPE, validatorComp } from '../base'
// import validatorCompCurrentProject from '@/compositions/modules/validator'

import { useI18n } from '@/plugins/i18n'
const { isLocal } = useI18n()

const { validateEmail, validatePassword, validateEmailUniqueness } = validatorComp()
// const { validatePasswordCurrentProject } = validatorCompCurrentProject()

const BindEmailReq = [
  {
    prop: 'email',
    label: t('user.register.placeholder.text_1'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', validator: validateEmail },
      { trigger: 'blur', validator: validateEmailUniqueness }
    ],
    default: ''
  }, {
    prop: 'emailCode',
    label: t('user.register.placeholder.text_2'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('user.register.placeholder.text_2') }
    ],
    default: ''
  }, {
    prop: 'emailId',
    rules: [
      { required: true, trigger: 'blur', message: t('user.register.placeholder.text_2') }
    ],
    default: ''
  }
]

const RegisterReq = [
  {
    prop: 'zoneNumber',
    type: REQ_ITEM_TYPE.SELECT,
    rules: [
      { required: true, trigger: 'blur', message: t('modules.register.validate.zoneNumber') }
    ],
    default: isLocal ? '+86' : '+65'
  }, {
    prop: 'mobile',
    label: t('user.register.placeholder.text_3'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhone') }
    ],
    default: ''
  }, {
    prop: 'mobileCode',
    label: t('user.register.error.text_4'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhoneCode') }
    ],
    default: ''
  }, {
    prop: 'mobileId',
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhoneCode') }
    ],
    default: ''
  }, {
    prop: 'email',
    label: t('user.register.placeholder.text_1'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', validator: validateEmail },
      { trigger: 'blur', validator: validateEmailUniqueness }
    ],
    default: ''
  }, {
    prop: 'emailCode',
    label: t('user.register.error.text_2'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.emailCode') }
    ],
    default: ''
  }, {
    prop: 'emailId',
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.emailCode') }
    ],
    default: ''
  }, {
    prop: 'password',
    label: t('modules.register.label.loginPwd'),
    placeholder: t('user.register.placeholder.text_4'),
    rules: [
      { required: true, trigger: 'blur', message: t('user.register.placeholder.text_4') },
      { trigger: 'blur', validator: validatePassword }
    ],
    default: ''
  }, {
    prop: 'confirmPwd',
    label: t('user.register.placeholder.text_5'),
    rules: [
      { required: true, trigger: 'blur', message: t('user.register.placeholder.text_5') }
    ],
    default: ''
  }, {
    prop: 'protocol',
    rules: [
      { type: 'array', required: true, message: t('user.register.error.text_5'), trigger: 'change' }
    ],
    default: false
  }, {
    prop: 'privacyCrossBorder',
    rules: [
      { type: 'array', required: true, message: t('user.register.error.text_6'), trigger: 'change' }
    ],
    default: false
  }, {
    prop: 'inviteCode',
    label: t('user.register.placeholder.text_6'),
    default: ''
  }, {
    prop: 'recommendName',
    label: t('user.register.placeholder.text_6'),
    default: ''
  }
]

export {
  RegisterReq,
  BindEmailReq
}
